import * as Yup from 'yup';
import { RegularExpressions } from '../../../../TCSMApp/global/constants/regular-expressions';
import { EcdClergySettingsProps } from '../../models/epi-model';

const defaultFieldOnlySpacesMessage = 'The field should not be only white spaces.';

export interface ClergyQuickSearchFormValues {
	name?: string;
	cityOrCountry?: string;	
}

export interface ClergyAdvancedSearchFormValues {
	first_name?: string;
	last_name?: string;	
	location?: string;
	zip_code?: string;
	canonicalResidence?: string;
	is_bishop?: string;
}

export function QuickSearchFormValidationSchema(clergySettings : EcdClergySettingsProps){	
	return Yup.object().shape({			
		name: Yup.string().nullable().matches(RegularExpressions.StringNotOnlySpaces, clergySettings?.fieldOnlySpacesMessage || defaultFieldOnlySpacesMessage),
		cityOrCountry: Yup.string().nullable().matches(RegularExpressions.StringNotOnlySpaces, clergySettings?.fieldOnlySpacesMessage || defaultFieldOnlySpacesMessage),
	});	
}

export function AdvancedSearchFormValidationSchema(clergySettings : EcdClergySettingsProps){	
   return Yup.object().shape({			
	first_name: Yup.string().nullable().matches(RegularExpressions.StringNotOnlySpaces, clergySettings?.fieldOnlySpacesMessage || defaultFieldOnlySpacesMessage),
	last_name: Yup.string().nullable().matches(RegularExpressions.StringNotOnlySpaces, clergySettings?.fieldOnlySpacesMessage || defaultFieldOnlySpacesMessage),
	location: Yup.string().nullable().matches(RegularExpressions.StringNotOnlySpaces, clergySettings?.fieldOnlySpacesMessage || defaultFieldOnlySpacesMessage),
	zip_code: Yup.string().nullable().matches(RegularExpressions.StringNotOnlySpaces, clergySettings?.fieldOnlySpacesMessage || defaultFieldOnlySpacesMessage),	   
	canonicalResidence: Yup.object().nullable(),	   
	is_bishop: Yup.string().nullable(),
   });
}

export interface ClergyNameQuickSearchResult {
	name: string;
	guid: string;
	party_id?: string;	
	position?: string;
}

export interface ClergyLocationQuickSearchResult {
	location: string;	
}

export interface Clergy {
	guid: string;
	first_name?: string;
	last_name?: string;	
	middle_name?: string;
	street_city?: string;
	street_state?: string;
	street_country?: string;	
}

export enum ClergySearchSort{
	FirstNameAsc = 'fname',
	LastNameAsc = 'lname',
	CityAsc = 'city',
	StateAsc = 'state',
	FirstNameDesc = 'fname_desc',
	LastNameDesc = 'lname_desc',
	CityDesc = 'city_desc',
	StateDesc = 'state_desc',
}

export interface ClergyFilters {
	name?: string;
	first_name?: string;
	last_name?: string;	
	zip_code?: string;
	location?: string;
	c_res?: string;
	is_bishop?: string;
	sort?: ClergySearchSort;	
	page?: string;
}

export class ClergyQueryStringParameters {
	public static readonly Name = 'name';

	public static readonly FirstName = 'first_name';

	public static readonly LastName = 'last_name';

	public static readonly ZipCode = 'zip_code';

	public static readonly CanonicalResidence = 'c_res';

	public static readonly IsBishop = 'is_bishop';

	public static readonly Location = 'location';

	public static readonly Sort = 'sort';

	public static readonly Page = 'page';
}

export enum SearchContext{
	Search = 'search',
	AdvancedSearch = 'advancedSearch',
	Results = 'results',	
	Detail = 'detail',	
	DetailParish = 'detailParish',	
	Mail = 'mail',	
}

// Clergy detail
export interface PublishedAddress {
	address1: string;
	address2?: any;
	address3?: any;
	city: string;
	state: string;
	postal_code: string;
	country: string;
}

export interface EmployerAddress {
	address1: string;
	address2?: any;
	address3?: any;
	city: string;
	state: string;
	postal_code: string;
	country: string;
}

export interface PrincipalPosition {
	position_title: string;
	start_date?: number;
	end_date?: string;
	employer_name?: string;
	employer_id?: string;
	employer_address?: EmployerAddress;
	employer_phone_number?: string;
}

export interface DiaconalData {
	deacon_date: string;
	bishop: string;
	diocese: string;
}

export interface PriestingData {
	priesting_date: string;
	bishop: string;
	diocese: string;
}

export interface BishopConsecrationData {
	consecration_date: string;
	consecrators?: string[];
	diocese?: string;
}

export interface OrdinationInformation {
	diaconal_data?: DiaconalData;
	priesting_data?: PriestingData;
	bishop_consecration_data?: BishopConsecrationData;
}

export interface ReceivedData {
	received_date: string;
	from?: string;
	order?: string;
	receiving_bishop?: string;
}

export interface TransferData {
	transfer_date: string;
	transferred_province: string;
	transfer_bishop: string;
}

export interface ClergyComplete {
	id: string;
	full_name: string;
	email_address?:string;
	published_address?: PublishedAddress;
	canonical_residence?: string;
	principal_positions?: PrincipalPosition[];
	ordination_information?: OrdinationInformation;
	received_data?: ReceivedData;
	transfer_data?: TransferData;
}

export function IsLocalClergy(clergy: Clergy) : boolean{
	return !clergy?.street_country || clergy?.street_country?.toLocaleUpperCase() === 'US';
}